import { useMemo, useState } from "react";
import styles from "./DinamRoutes.module.css";

const STATUSES = [
  "Создана",
  "Активна",
  "Доставлена",
  "Недоставлена",
  "Перенесена",
  "Отменена",
];

const STATUS_TONE = {
  Создана: "gray",
  Активна: "blue",
  Доставлена: "green",
  Недоставлена: "orange",
  Перенесена: "purple",
  Отменена: "red",
  Самовывоз: "teal",
  Удалена: "dark",
};

const ADDRESSES = [
  "ул. Ленина 15",
  "пр. Мира 42",
  "ул. Советская 8",
  "ул. Гагарина 21",
  "пр. Победы 101",
  "ул. Кедровая 6",
  "ул. Парковая 19",
];

const randomAddress = () =>
  ADDRESSES[Math.floor(Math.random() * ADDRESSES.length)];

const randomQty = () => Math.floor(Math.random() * 5) + 1;

function calcQty(route) {
  return route.receipts.reduce((sum, r) => sum + r.qty, 0);
}

export default function DinamRoutes() {
  const [routes, setRoutes] = useState([
    {
      id: 1,
      status: "Сформирован",
      maxQty: 20,
      receipts: Array.from({ length: 10 }, (_, i) => ({
        number: 1000 + i,
        status: "Создана",
        address: randomAddress(),
        qty: randomQty(),
        transferCount: 0,
      })),
    },
  ]);

  const [trash, setTrash] = useState([]);
  const [filterUndelivered, setFilterUndelivered] = useState(false);

  // modal: { routeId, receipt }
  const [modal, setModal] = useState(null);

  const nextRouteId = useMemo(() => {
    const maxId = routes.reduce((m, r) => Math.max(m, r.id), 0);
    return maxId + 1;
  }, [routes]);

  const createRoute = () => {
    setRoutes((prev) => [
      ...prev,
      { id: nextRouteId, status: "Сформирован", maxQty: 20, receipts: [] },
    ]);
  };

  const openRoute = (routeId) => {
    setRoutes((prev) =>
      prev.map((r) => {
        if (r.id !== routeId) return r;
        return {
          ...r,
          status: "Открыт",
          receipts: r.receipts.map((rec) =>
            rec.status === "Доставлена" ? rec : { ...rec, status: "Активна" }
          ),
        };
      })
    );
  };

  const changeReceiptStatus = (routeId, receiptNumber, status) => {
    setRoutes((prev) =>
      prev.map((r) =>
        r.id === routeId
          ? {
              ...r,
              receipts: r.receipts.map((rec) =>
                rec.number === receiptNumber ? { ...rec, status } : rec
              ),
            }
          : r
      )
    );
  };

  const changeRouteMaxQty = (routeId, value) => {
    const parsed = Number(value);
    const safe = Number.isFinite(parsed) ? Math.max(0, Math.min(999, parsed)) : 0;

    setRoutes((prev) =>
      prev.map((r) => (r.id === routeId ? { ...r, maxQty: safe } : r))
    );
  };

  const moveToTrash = () => {
    if (!modal) return;
    const { routeId, receipt } = modal;

    setTrash((prev) => [...prev, receipt]);

    setRoutes((prev) =>
      prev.map((r) =>
        r.id === routeId
          ? {
              ...r,
              receipts: r.receipts.filter((rec) => rec.number !== receipt.number),
            }
          : r
      )
    );

    setModal(null);
  };

  // перенос ТОЛЬКО в новый маршрутный лист (id = nextRouteId)
  const transferToNewRoute = () => {
    if (!modal) return;
    const { routeId, receipt } = modal;

    const newRoute = {
      id: nextRouteId,
      status: "Сформирован",
      maxQty: 20,
      receipts: [
        {
          ...receipt,
          status: "Перенесена",
          transferCount: receipt.transferCount + 1,
        },
      ],
    };

    setRoutes((prev) => {
      const updated = prev.map((r) =>
        r.id === routeId
          ? {
              ...r,
              receipts: r.receipts.filter((rec) => rec.number !== receipt.number),
            }
          : r
      );
      return [...updated, newRoute];
    });

    setModal(null);
  };

  const transferReceiptToRoute = (targetRouteId) => {
    if (!modal) return;
    const { routeId, receipt } = modal;

    setRoutes((prev) =>
      prev.map((r) => {
        // убрать из текущего МЛ
        if (r.id === routeId) {
          return {
            ...r,
            receipts: r.receipts.filter(
              (rec) => rec.number !== receipt.number
            ),
          };
        }

        // добавить в целевой МЛ
        if (r.id === targetRouteId) {
          return {
            ...r,
            receipts: [
              ...r.receipts,
              {
                ...receipt,
                status: "Перенесена",
                transferCount: receipt.transferCount + 1,
              },
            ],
          };
        }

        return r;
      })
    );

    setModal(null);
  };


  return (
    <div className={styles.wrapper}>
      <div className={styles.topBar}>
        <button
          className={styles.secondaryBtn}
          onClick={() => setFilterUndelivered((v) => !v)}
        >
          {filterUndelivered ? "Показать все" : "Показать недоставленные"}
        </button>
      </div>

      <div className={styles.board}>
        {routes.map((route) => {
          const currentQty = calcQty(route);
          const overload = currentQty > route.maxQty;

          return (
            <section key={route.id} className={styles.routeCard}>
              <header className={styles.routeHeader}>
                <div className={styles.routeHeaderTop}>
                  <div className={styles.routeTitle}>Маршрутный лист {route.id}</div>

                  {route.status !== "Открыт" ? (
                    <button className={styles.primaryBtn} onClick={() => openRoute(route.id)}>
                      Открыть
                    </button>
                  ) : (
                    <div className={styles.routeOpened}>Открыт</div>
                  )}
                </div>

                <div className={styles.routeMetaGrid}>
                  <div className={styles.routeMetaRow}>
                    <div className={styles.metaLabel}>Статус</div>
                    <div className={styles.metaValue}>{route.status}</div>
                  </div>

                  <div className={styles.routeMetaRow}>
                    <div className={styles.metaLabel}>Макс. объём</div>
                    <div className={styles.metaValue}>
                      <input
                        className={styles.maxQtyInput}
                        type="number"
                        min="0"
                        max="999"
                        value={route.maxQty}
                        onChange={(e) => changeRouteMaxQty(route.id, e.target.value)}
                      />
                    </div>
                  </div>

                  <div className={styles.routeMetaRow}>
                    <div className={styles.metaLabel}>Текущий объём</div>
                    <div className={`${styles.metaValue} ${overload ? styles.overload : ""}`}>
                      {currentQty}
                      {overload ? " (превышен)" : ""}
                    </div>
                  </div>
                </div>
              </header>

              <div className={styles.receipts}>
                {route.receipts
                  .filter((rec) => (filterUndelivered ? rec.status == "Недоставлена" : true))
                  .map((rec) => {
                    const tone = STATUS_TONE[rec.status] || "gray";
                    return (
                      <article
                        key={rec.number}
                        className={`${styles.receipt} ${styles[`receipt_${tone}`]}`}
                      >
                        <div className={styles.receiptTop}>
                          <div className={styles.receiptTitle}>Квитанция {rec.number}</div>
                          <span className={`${styles.badge} ${styles[`badge_${tone}`]}`}>
                            {rec.status}
                          </span>
                        </div>

                        <div className={styles.receiptLine}>Адрес: {rec.address}</div>
                        <div className={styles.receiptLine}>Количество: {rec.qty}</div>
                        <div className={styles.receiptLine}>Переносов: {rec.transferCount}</div>

                        <div className={styles.controlsRow}>
                          <select
                            className={styles.control}
                            value={rec.status}
                            onChange={(e) =>
                              changeReceiptStatus(route.id, rec.number, e.target.value)
                            }
                          >
                            {STATUSES.map((s) => (
                              <option key={s} value={s}>
                                {s}
                              </option>
                            ))}
                          </select>

                          {rec.status !== "Доставлена" &&
                            rec.status !== "Отменена" && (
                            <button
                              className={`${styles.control} ${styles.actionBtn}`}
                              onClick={() =>
                                setModal({ routeId: route.id, receipt: rec })
                              }
                            >
                              Действие
                            </button>
                          )}

                        </div>
                      </article>
                    );
                  })}
              </div>
            </section>
          );
        })}

        <button className={styles.addRoute} onClick={createRoute} aria-label="Добавить маршрутный лист">
          +
        </button>

        <aside className={styles.trash}>
          <div className={styles.trashTitle}>Корзина</div>

          {trash.length === 0 ? (
            <div className={styles.trashEmpty}>Пусто</div>
          ) : (
            <div className={styles.trashList}>
              {trash.map((rec) => (
                <div key={rec.number} className={styles.trashItem}>
                  <div className={styles.trashItemTitle}>Квитанция {rec.number}</div>
                  <div className={styles.trashItemMeta}>Адрес: {rec.address}</div>
                </div>
              ))}
            </div>
          )}
        </aside>
      </div>

      {modal && (
        <div
          className={styles.modalOverlay}
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) setModal(null);
          }}
        >
          <div className={styles.modal} role="dialog" aria-modal="true">
            <div className={styles.modalTitle}>Квитанция {modal.receipt.number}</div>
            <div className={styles.modalText}>Адрес: {modal.receipt.address}</div>
            <div className={styles.modalText}>Количество: {modal.receipt.qty}</div>

            <div className={styles.modalActions}>
              <button
                className={styles.primaryBtn}
                onClick={transferToNewRoute}
              >
                Перенести в новый маршрутный лист {nextRouteId}
              </button>

              {routes
                .filter((r) => r.id !== modal.routeId)
                .map((r) => (
                  <button
                    key={r.id}
                    className={styles.secondaryBtn}
                    onClick={() => transferReceiptToRoute(r.id)}
                  >
                    Перенести в маршрутный лист {r.id}
                  </button>
                ))}

              <button
                className={styles.dangerBtn}
                onClick={moveToTrash}
              >
                Удалить
              </button>

              <button
                className={styles.secondaryBtn}
                onClick={() => setModal(null)}
              >
                Отмена
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}
